// extracted by mini-css-extract-plugin
export default {"page":"Privacy_page__JzS1x","container":"Privacy_container__XNWxP","updated":"Privacy_updated__egPZ4"};